export const environment = {
  production: false,
  appVersion: '0.0.2',
  androidAppVersion: 100003,
  restAPI: 'https://stage-api-v2.bag2bag.in/v2/',
  restApiForVideo: 'https://stage-api-v2.bag2bag.in/v2/',
  schedulerRestAPI: 'https://stage-api-v5.bag2bag.in/v2/',
  cacheVersion: 1,
  cacheKey: '_mst_:ch_',
  encryptedKey: 'hello world',
  gtmId: 'GTM-PWBBZ3N',
  appShellConfig: {
    debug: false,
    networkDelay: 1000,
  },
  enquiryRestAPI: 'https://stage-api-v2.bag2bag.in/v2/enquiry-service/create',
  //'https://stage-api.bag2bag.in/rest/anonymous/api/enquiry/general',

  s3BucketRootPath: 'https://static.bag2bag.in/temp/images/',
  s3BucketVideoBaseUrl: 'https://static.bag2bag.in/',
  /**
   * @deprecated
   */
  s3BucketImageBaseUrl:
    'https://static.bag2bag.in/temp/images/property-images/img-949x449/',
  s3BucketAmenitiesBaseUrl:
    'https://static.bag2bag.in/new-assets/india/new-app/amenities/',
  errorPlaceholder:
    'https://d3262fryr7kj73.cloudfront.net/new-assets/india/new-app/icons/placeholder_blue.png',
  pushNotificationConfig: {
    android: {
      topicConfig: {
        topicName: 'B2B_STAGE_ANDROID_TOPICS',
        defaultChannel: {
          id: '1',
          name: 'Android PN Channel',
        },
        topicArnHints: 'Select topic with word STAGE.',
      },
    },
    ios: {
      topicConfig: {
        topicName: 'B2B_STAGE_IOS_TOPICS',
      },
    },
  },
  GOOGLE_MAP_API_KEY: 'AIzaSyB2nOCl1zfIBWAe2F6mIj_smc2WWwQv0GE',
  EXTERNAL_SERVER_FE_WEB_API: 'https://stage.bag2bag.in',
  SERVER_OPTIONS: [
    {
      id: 'server1',
      label: 'Server 1 (port 9000)',
      apiBaseUrl: 'https://stage-api-v2.bag2bag.in/v2/',
    },
  ],
};
